﻿import { FiX } from 'react-icons/fi';

interface FilterChip {
  key: string;
  label: string;
  value: string;
  displayValue: string;
}

interface Props {
  chips: FilterChip[];
  onRemove: (key: string) => void;
  onClearAll: () => void;
}

export default function FilterChips({ chips, onRemove, onClearAll }: Props) {
  if (chips.length === 0) return null;

  return (
    <div className="d-flex flex-wrap align-items-center gap-2">
      {chips.map(chip => (
        <span key={chip.key} className="filter-chip">
          <span className="filter-chip-label">{chip.label}:</span>
          <span className="filter-chip-value">{chip.displayValue}</span>
          <button className="filter-chip-remove" onClick={() => onRemove(chip.key)}>
            <FiX />
          </button>
        </span>
      ))}
      {chips.length > 1 && (
        <button className="btn btn-link btn-sm text-muted p-0" style={{ fontSize: 11 }} onClick={onClearAll}>
          Rimuovi tutti
        </button>
      )}
    </div>
  );
}

